// src/components/free-trial/PreparingYourProfile.tsx
import { useEffect } from 'react';
import { OnboardingStepProps } from '../../registration';
import { ContentSection } from '../secure-your-account/secure-your-account.styled';
import styled from '@emotion/styled';
import { UniversalSpinner } from '../../../../components/universal-spinner/universal-spinner';
import { VSpace } from '../../../chat/settings/account/account-settings';

export const PreparingText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 18px;
  leading-trim: NONE;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #b7bdcb;
`;
export const PreparingYourProfile: React.FC<OnboardingStepProps> = ({ goNext }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      goNext();
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <ContentSection data-testid="ob-trial">
      <div />
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <PreparingText>Preparing your profile page…</PreparingText>
        <VSpace $h={16} />
        <UniversalSpinner />
      </div>
      <div />
    </ContentSection>
  );
};

(PreparingYourProfile as any).background = 'linear-gradient(180deg, #222327 0%, #1A1A1C 100%);';
(PreparingYourProfile as any).progress = 'Setup';
(PreparingYourProfile as any).smallLogo = true;
(PreparingYourProfile as any).fill = false;
